import React from "react";
import LogoBg from "../../Images/metamorphicLogo.png";
import "./Logo.scss";

const Logo = () => <img className="logo" src={LogoBg} alt="logo" />;

export default Logo;
